import { authedFetch } from './authedFetch';

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchCourses() {
  const res = await fetch(`${API_URL}/api/courses`);
  if (!res.ok) throw new Error('Failed to load courses.');
  return res.json();
}

// Lesson bodies are withheld from anonymous callers (ADR-0012), and the
// caller's own progress rides along on the same response, so this sends the
// session token whenever there is one. `getToken` is optional: the anonymous
// answer -- syllabus without prose -- is a real answer, not a failure, and the
// catalogue and course pages are meant to work signed out.
//
// The response carries `lessonBodiesIncluded` so a page can tell "signed out"
// apart from "this lesson genuinely has no content".
export async function fetchCourse(slug, getToken) {
  const token = getToken ? await getToken().catch(() => null) : null;
  const res = await fetch(`${API_URL}/api/courses/${slug}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('Failed to load course.');
  return res.json();
}

export async function fetchMyEnrollments(getToken) {
  return authedFetch(getToken, '/api/enrollments/me');
}

export async function enrollInCourse(getToken, courseSlug) {
  return authedFetch(getToken, '/api/enrollments', {
    method: 'POST',
    body: JSON.stringify({ courseSlug }),
  });
}

export async function markLessonComplete(getToken, courseSlug, lessonSlug) {
  return authedFetch(getToken, `/api/enrollments/${courseSlug}/lessons/${lessonSlug}/complete`, {
    method: 'POST',
  });
}

// Every work the curriculum assigns, derived from Lesson.readings (ADR-0007)
// rather than kept as a second, drifting list.
export async function fetchBibliography() {
  const res = await fetch(`${API_URL}/api/courses/bibliography`);
  if (!res.ok) throw new Error('Failed to load the bibliography.');
  return res.json();
}
